import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ToastController } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';
import { PopupPage } from '../../../popup/popup';

/**
 * Generated class for the EditagrculturePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editagrculture',
  templateUrl: 'editagrculture.html',
})
export class EditagrculturePage {
  cb: any
  id = -1
  name = ''
  selectedProcName = ''
  selectedProcIds = []
  selC = []
  procArray = []
  values: Array<string> = [];
  arrayChecked = []
  processids = ''

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public popoverCtrl: PopoverController, public toastCtrl: ToastController) {
    this.id = this.navParams.get('id')
    this.name = navParams.get('name')
    this.cb = navParams.get('cb')
    this.processids = navParams.get('processids')
    if (this.id + '' != '-1' && this.processids != null && this.processids != '') {
      this.selectedProcIds = this.processids.split(',')
    }
    this.selectedProcName = '-- ' + this.dic.l["chooseProcesses"] + ' --'
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditagrculturePage');
    this.getProcesses()
  }

  doSave(_id, _name, _op) {
    // console.log(_id, _name, _op)
    var _that = this
    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      id: this.gn.crypt(_id),
      name: this.gn.crypt(_name),
      op: this.gn.crypt(_op),
      processids: this.gn.crypt(this.selectedProcIds.join(',')),
      type: this.gn.crypt('Culture')
    }
    this.gn._Post('/api/gn/addcolutures', _dat, function (_data) {
      _that.cb()
      _that.navCtrl.pop()
    })
  }

  getProcesses() {
    var _that = this;
    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId)
    }
    this.gn._Post('/api/gn/getProcesses', _dat, function (_data) {
      for (var i = 0; i < _data.length; i++) {
        _that.procArray.push({ name: _data[i].processname, id: _data[i].id })
      }

      if (_that.id + '' != '-1' && _that.processids != null && _that.processids != '') {
        for (var j = 0; j < _that.selectedProcIds.length; j++) {
          for (var k = 0; k < _that.procArray.length; k++) {
            if (_that.procArray[k].id + '' == _that.selectedProcIds[j] + '') {
              _that.arrayChecked.push({ id: _that.procArray[k].id, name: _that.procArray[k].name, flag: true })
              _that.selC.push(_that.procArray[k].name)
            }
          }
        }
        _that.selectedProcName = _that.selC.join(', ')
      }
    })
  }

  reorderItems(from, to) {
    let element = this.arrayChecked[from];
    this.arrayChecked.splice(from, 1);
    this.arrayChecked.splice(to, 0, element);

    let element1 = this.selC[from];
    this.selC.splice(from, 1);
    this.selC.splice(to, 0, element1);

    let element2 = this.selectedProcIds[from];
    this.selectedProcIds.splice(from, 1);
    this.selectedProcIds.splice(to, 0, element2);

    this.selectedProcName = this.selC.join(', ')
  }

  deleteProcess(idx) {
    this.arrayChecked.splice(idx, 1)
    this.selC.splice(idx, 1)
    this.selectedProcIds.splice(idx, 1)
    this.selectedProcName = this.selC.join(', ')
  }
  pickProc(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'processes', selected: '', arrayData: this.procArray, selProcId: this.selectedProcIds, callback: function (_c, _p) {
        //_that.selectedProcIds = [];

        _that.values = [];
        for (var i = 0; i < _p.length; i++) {
          if (_p[i].ch) {

            if (_that.arrayChecked.length > 0) {
              var found = false;
              for (var ii = 0; ii < _that.arrayChecked.length; ii++) {
                if (_that.arrayChecked[ii].id == _p[i].id) {
                  found = true;
                  break;
                }
              }
              if (found == false) {
                _that.arrayChecked.push({ id: _p[i].id, name: _p[i].name, flag: _p[i].ch })
                _that.selectedProcIds.push(_p[i].id)
                _that.selC.push(_p[i].name)

              }
            } else {
              _that.arrayChecked.push({ id: _p[i].id, name: _p[i].name, flag: _p[i].ch })
              _that.selectedProcIds.push(_p[i].id)
              _that.selC.push(_p[i].name)

            }
          } else {
            //debugger
            if (_that.arrayChecked.length > 0) {
              for (let j = 0; j < _that.arrayChecked.length; j++) {
                if (_p[i].id == _that.arrayChecked[j].id) {
                  _that.arrayChecked.splice(j, 1)
                  _that.selectedProcIds.splice(j, 1)
                  _that.selC.splice(j, 1)
                  //debugger
                }
              }
            }
          }
        }
        //debugger
        if (_that.selC.length > 0)
          _that.selectedProcName = _that.selC.join(', ')
        else
          _that.selectedProcName = '-- ' + _that.dic.l["chooseProcesses"] + ' --'
      }
    }, { cssClass: 'popover-content-processes' });
    popover.present({ ev: _ev });
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/agrculture/editagrculture/editagrculture.ts